<template>
    <div class="gk-box">
        <div class="gk-box-bg">
            <Breadcrumb></Breadcrumb>
            <div class="gk-box-infor">
                <div>
                    <h3>生涯管理平台</h3>
                    <p>告别传统文理科，荔枝新高考时刻关注学生的成长、生涯规划，助学生走好人生关键一步</p>
                    <a href="https://xgk.zmpajx.com/#/scl_login" target="_blank"><el-button>开始使用</el-button></a>
                </div>
                <img src="@/assets/images/gk_img1.png">
            </div>
            <div class="gk-tools">
                <h4>新高考工具</h4>
                <div class="gk-subject">
                    <div v-for="(item, index) in toolsList" :key="index" @click="gotoPath('/querySubject', index)">
                        <div class="tool-img">
                            <img :src="item.src">
                        </div>
                        <div>
                            <div class="tool-title">
                                {{ item.name }}
                                <i class="el-icon-arrow-right"></i>
                            </div>
                            <div class="tool-desc">
                                {{ item.desc }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="gk-common">
            <h4>平台特色</h4>
            <h5>PLATFORM  FEATURES</h5>
            <div class="gk-flex">
                <div class="gk-left">
                    <img src="@/assets/images/gk_img2.png" class="test-img1">
                    <div class="gk-flex">
                        <el-carousel class="test-img" arrow="always" :autoplay="false" :initial-index="testIndex">
                            <el-carousel-item v-for="(item, index) in testImg" :key="item">
                            <img :src="item">
                            </el-carousel-item>
                        </el-carousel>
                        <div>
                            <div v-for="(item, index) in testList" :key="index" @click="changeTest(index)" :class="['test-view',activeIndex === index ? 'test-view-active': '']">
                                {{  item.name }}
                            </div>
                        </div>
                    </div>
                    <h3><span style="color: #2472ff;">丰富的</span>生涯评测功能</h3>
                    <p>通过权威测评，从兴趣、性格、能力、职业倾向、学科优劣等多维度科学定位适合学生的专业方向，帮助学校了解每个学生。</p>
                </div>
                <div class="gk-right">
                    <div class="gk-walk right-common">
                        <img src="@/assets/images/gk_img3.png" class="gk-walk-bg">
                        <h3><span>专业的</span>新高考走班排课工具</h3>
                        <p>根据各校不同的资源与生源情况，进行特色智能排课，支持分层走班的各类走班模式排课，兼顾学校各项资源配置与学生的个性化发展。</p>
                        <img src="@/assets/images/gk_img4.png" class="gk-walk-img">
                    </div>
                    <div class="gk-record right-common">
                        <div>
                            <h3 style="color: #ffbd55;">智能的</h3>
                            <h3>生涯档案统计</h3>
                            <p>通过对学生过程性数据的记录、整理、评价、分析，为学生输出过程性成长报告及终结性评价档案。</p>
                        </div>
                        <img src="@/assets/images/gk_img5.png" class="gk-walk-img">
                    </div>
                </div>
            </div>
        </div>
        <div class="gk-common gk-service">
            <h4>服务内容</h4>
            <h5>SERVICE CONTENT</h5>
            <div v-for="(item, index) in serviceList" class="gk-flex service-item">
                <div :class="['service-left', `service-color${index}`]">
                    <img :src="item.src">
                    <h4 v-html="item.title"></h4>
                </div>
                <div v-html="item.desc" class="service-right"></div>
            </div>
        </div>
        <div class="gk-contact">
            <img src="@/assets/images/subject_bg_left.png" class="img-left">
            <img src="@/assets/images/subject_bg_right.png" class="img-right">
            <div class="gk-common">
                <h4>联系我们</h4>
                <h5>CONTACT US</h5>
                <p>如果您对新高考管理平台感兴趣，请留下您的联系方式吧！</p>
                <el-row>
                    <el-form :model="formInline" ref="formInline" class="contact-form" :rules="rules">
                        <el-form-item prop="phone">
                            <el-input v-model="formInline.phone" placeholder="联系电话"><img src="@/assets/images/gk_icon7.png" slot="suffix" /></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
import { mapState } from 'vuex'

export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            toolsList: [
                {src: require('../../assets/images/gk_icon1.png'),name: '由科目选专业',desc: '通过选择科目组合，智能查询可以报考的院校和专业',path: ''},
                {src: require('../../assets/images/gk_icon2.png'),name: '由专业选科目',desc: '通过选择院校和专业，智能配备报考需要的科目',path: ''},
                {src: require('../../assets/images/gk_icon3.png'),name: '选考科目查询',desc: '查询所有院校的各专业报考所需的科目选择要求',path: ''},
            ],
            testList: [
                { id: 'xingqu', name: '兴趣评估' }, 
                { id: 'xingge', name: '性格评估' }, 
                { id: 'juandai', name: '学习倦怠' }, 
                { id: 'nengli', name: '学习能力' }, 
                { id: 'tuoyan', name: '学习拖延' }, 
                { id: 'kongzhi', name: '自我控制能力' }, 
                { id: 'xinli', name: '考试心理和行为' }
            ],
            activeIndex: 0,
            testIndex: 0,
            testImg: [],
            serviceList: [
                {
                    src: require('../../assets/images/gk_icon4.png'),
                    title: '针对<br>学校',
                    desc:'<p>为学校<span class="text-diff">免费提供</span>一整套的新高考综合管理平台</p><p>① 提供<span>走班排课系统</span>，个性化定制新高考形式下的排课工作，方便教学管理。</p><p>② 提供<span>生涯资源系统</span>，支持学校开展生涯课程，提升教师生涯素养。</p><p>③ 提供<span>教学评价系统</span>，可实现分层走班制下的教学质量检测和反馈。</p><p>④ 提供<span>选科决策系统</span>，为学校提供便捷有效的选科工具。</p><p>⑤ 提供<span>新高考公益讲座服务</span>，高一、高二、高三分层讲座，每学年累计开展7-8场讲座。</p><p>⑥ 提供<span>专家团队指导一对一服务</span>，提供系统操作指导培训及后续的各项服务对接。</p>'
                },
                {
                    src: require('../../assets/images/gk_icon5.png'),
                    title: '针对<br>学生',
                    desc:'<p>① 提供<span>生涯测评系统</span>，帮助学生了解自己，确定未来想成为什么样的人。</p><p>② 提供<span>学科决策指导</span>，帮助学生明确专业意向，再确定这些专业所需要选择的科目。</p><p>③ 提供<span>新高考课程学习打卡服务</span>，内容涵盖政策解读、兴趣探索、职业认知，到大学及专业了解，志愿填报等升学规划方方面面。</p><p>④ 提供<span>学职信息查询服务</span>，全国3000+大学和历年专业录取数据、700+专业介绍，帮助学生快速了解意向高校及专业招录情况、就业前景、毕业去向、薪资情况等。</p><p>⑤ <span class="text-diff">提供多达38项高报功能的高考志愿填报系统服务</span>，权威的高考数据，帮助学生进行志愿填报，确定能被适合的院校录取。</p>'
                },
                {
                    src: require('../../assets/images/gk_icon6.png'),
                    title: '针对<br>家长',
                    desc:'<p>① 提供<span>家校共育系统服务</span>，学生生涯测评报告、学生成绩推送、生涯成长档案，让家长参与了解学生的生涯规划及学习情况。</p><p>② 提供<span>生涯规划社群咨询服务</span>，根据高一高二高三不同年级配备多种生涯规划专属社群，提供生涯规划、选科决策、志愿填报等线上专属咨询服务。</p>'
                }
            ],
            formInline: {
                username: '',
                phone: '',
                type: '16'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            }
        };
    },

    mounted() {
        for (let i = 1; i <= 4; i++) {
            const url = require('../../assets/images/test/'+  this.testList[this.activeIndex].id + '/' + i + '.png')
            this.testImg.push(url)
        }
    },
    computed: {
        ...mapState({
            token: state => state.user.token
        }),
    },
    methods: {
        addSubscribeHandler() {
            let that = this
            that.formInline.username = that.formInline.phone
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        },
        changeTest(index) {
            this.testImg = []
            this.activeIndex = index
            // this.$forceUpdate()
            for (let i = 1; i <= 4; i++) {
                const url = require('../../assets/images/test/'+ this.testList[this.activeIndex].id + '/' + i + '.png')
                this.testImg.push(url)
            }
            // this.testIndex = 0
        },
        gotoPath(path, index) {
            if(!this.token) {
                this.$store.commit('user/LOGINSTATUS', true);
                return
            };
            sessionStorage.setItem('active_index', Number(index))
            this.$router.push({
                path: path
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$width: 1200px;
$margin: 0 auto;
@font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
$font-family: 'MicrosoftYaHei';
$margin: 0 auto;
.gk-box {
    margin-bottom: -56px;
    background: #fff;
}
.gk-box-bg {
    background: url('../../assets/images/gk_bg.png') no-repeat center;
    background-size: cover;
    width: 100%;
}
.gk-box-infor {
    width: $width;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 64px auto;
    p {
        font-size: 16px;
        font-weight: 400;
        color: #5e6166;
        line-height: 24px;
        width: 79%;
    }
    h3 {
        font-size: 44px;
        font-weight: 600;
        color: #332e2c;
        line-height: 62px;
        margin: 0 0 12px 0;
    }
    button {
        width: 136px;
        height: 50px;
        background: #2472ff!important;
        border: 1px solid #2472ff!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        margin-top: 28px;
    }
    button:hover {
        opacity: 0.8;
    }
    img {
        width: 481px;
        height: 280px;
    }
}
.gk-tools {
    width: $width;
    margin: $margin;
    h4 {
        font-size: 22px;
        font-weight: 600;
        color: #292d33;
        line-height: 30px;
        margin: 0;
        margin-bottom: 24px;
    }
    h4::before {
        display: inline-block;
        content: '';
        width: 3px;
        height: 20px;
        background: #ff6524;
        border-radius: 1px;
        position: relative;
        top: 2px;
        margin-right: 8px;
    }
    .gk-subject {
        display: flex;
        justify-content: space-between;
        > div {
            width: 384px;
            height: 126px;
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.08); 
            padding: 0 24px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            .tool-img {
                width: 56px;
                height: 56px;
                background: #f2f8ff;
                border: 1px solid #ebeef3;
                border-radius: 8px;
                padding: 12px;
                box-sizing: border-box;
                margin-right: 16px;
            }
            .tool-title {
                font-size: 18px;
                font-weight: 500;
                color: #292d33;
                line-height: 26px;
                i {
                    float: right;
                    color: #c4c7cc;
                    font-size: 16px;
                    position: relative;
                    top: 2px;
                }
            }
            .tool-desc {
                margin-top: 8px;
                font-size: 14px;
                color: #767a80;
                line-height: 20px;
            }
        }
        > div:hover {
            box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.08);
            .tool-title {
                color: #2472ff;
                i {
                    color: #2472ff;
                }
            }
        }
    }
}
.gk-common {
    width: $width;
    margin: $margin;
    h4 {
        font-size: 36px;
        font-weight: 700;
        text-align: center;
        color: #292d33;
        margin: 0;
        line-height: 50px;
        margin-top: 96px;
        position: relative;
        z-index: 99;
    }
    h5 {
        font-size: 26px;
        font-weight: 600;
        text-align: center;
        color: #d8dce6;
        line-height: 37px;
        margin: 0;
        position: relative;
        top: -24px;
        z-index: 9;
        margin-bottom: 32px;
    }
}
.gk-flex {
    display: flex;
    justify-content: space-between;
}
.gk-left, .gk-right {
    h3 {
        font-size: 32px;
        font-weight: 600;
        line-height: 45px;
        color: #FFFFFF;
        margin: 0;
    }
    p {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        margin: 0;
        width: 88%;
        margin: 16px 0 23px 0;
    }
}
.gk-left {
    width: 590px;
    box-sizing: border-box;
    padding: 48px 44px 48px 48px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08); 
    position: relative;
    h3 {
        color: #332E2C;
        margin: 35px 0 16px 0;
    }
    p {
        color: #66605e;
        width: 97%;
        margin: 0;
    }
    .test-img1 {
        position: absolute;
        top: 0;
        left: 0;
    }
    .test-img {
        width: 326px;
        height: 460px;
        border-radius: 8px;
        position: relative;
        z-index: 99;
    }
    .test-view {
        font-size: 14px;
        font-weight: 400;
        color: #5e6166;
        line-height: 20px;
        margin-bottom: 16px;
        position: relative;
        cursor: pointer;
    }
    .test-view-active {
        left: -16px;
        color: #2472ff;
        &::before {
            content: '';
            width: 0;
            height: 0;
            border-top: 7px solid transparent; 
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
            border-bottom: 7px solid #2472ff;
            position: absolute;
            left: -14px;
            top: 3px;
            transform: rotate(90deg);
        }
    }
}
.gk-right {
    .right-common {
        width: 570px;
        background: #332e2c;
        border-radius: 20px;
        padding: 48px 48px 0 48px;
        box-sizing: border-box;
        position: relative;
        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08); 
    }
    .gk-walk {
        background: linear-gradient(180deg,#328aff, #92bbff 100%);
        margin-bottom: 40px;
        height: 360px;
        .gk-walk-bg {
            position: absolute;
            z-index: 99;
            top: 0;
            right: 0;
        }
        h3 {
            span {
                color: #3ddf96;
            }
        }
    }
    .gk-record {
        background: #332e2c; 
        display: flex;
        padding-right: 0;
        padding-bottom: 48px;
        justify-content: space-between;
    }
}
.gk-service {
    .gk-flex {
        justify-content: start;
    }
    .service-item {
        border-radius: 20px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08); 
        margin-bottom: 32px;
    }
    .service-left {
        flex: 0 0 160px;
        padding: 44px 0;
        border-radius: 20px 0 0 20px;
        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08); 
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h4 {
            margin: 0;
            font-size: 28px;
            font-weight: 600;
            color: #ffffff;
            line-height: 36px;
            margin-top: 8px;
        }
        img {
            width: 56px;
            height: 56px;
        }
    }
    .service-color0 {
        background: #5793ff;
    }
    .service-color1 {
        background: #ff8557;
    }
    .service-color2 {
        background: #ffb257;
    }
}
.gk-contact {
    // background: url('../../assets/images/subject_bg_bottom.png');
    // height: 514px;
    position: relative;
    padding-bottom: 62px;
    .img-left {
        position: absolute;
        bottom: 0;
        left: 0;
    }
    .img-right {
        position: absolute;
        top: -67px;
        right: 0;
        z-index: 99;
    }
    p {
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        color: #292d33;
        line-height: 28px;
        margin-top: 78px;
    }
}
</style>